export const urls = {
    home: '/',
    error: '/error',
    assignedLeads: '/assigned-leads',
    campaigns: '/campaigns',
    templates: '/templates',
    logs: '/logs',
    reports: '/reports',
}